// extracted by mini-css-extract-plugin
export default {"ToastLink__HiddenMobile":"ToastLink-styles__ToastLink__HiddenMobile__BjKYy","ToastLink__MobileOnly":"ToastLink-styles__ToastLink__MobileOnly__P8wOZ"};